import { TicketRepository } from '../repositories/TicketRepository'

export function listAllResponsibleTheAreaCase(
  ticketRepository: TicketRepository
) {
  return async function () {
    return await ticketRepository.listAllResponsibleTheArea()
  }
}
